<template>
  <v-tooltip location="top">
    <template #activator="{ props: tooltipProps }">
      <div v-bind="tooltipProps" class="download-card">
        <div class="download-card__info">
          <div class="download-card__title">{{ title }}</div>
          <div class="download-card__description">{{ modelType }}</div>
        </div>
        <SVGIcon
          :iconName="'download'"
          :width="'24px'"
          :height="'24px'"
          class="download-card__icon"
        />
      </div>
    </template>
    <div><strong>{{ title }}</strong></div>
    <div v-if="modelType">{{ modelType }}</div>
  </v-tooltip>
</template>

<script setup>
import SVGIcon from '@/components/SVGIcon.vue';

const props = defineProps({
  title: { type: String, default: '' },
  modelType: { type: String, default: '' },
});
</script>

<style scoped lang="scss">
.download-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s ease;
  width: 100%;
  max-width: 400px;

  &:hover {
    border-color: #0066cc;
    box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
    color: #0066cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__description {
    font-size: 12px;
    color: #666666;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon {
    flex-shrink: 0;
    margin-left: 12px;
    color: #0066cc;
  }
}
</style>
